import { render, staticRenderFns } from "./UrunlerInfo.vue?vue&type=template&id=efee806a&scoped=true"
import script from "./UrunlerInfo.vue?vue&type=script&lang=ts"
export * from "./UrunlerInfo.vue?vue&type=script&lang=ts"
import style0 from "./UrunlerInfo.vue?vue&type=style&index=0&id=efee806a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efee806a",
  null
  
)

export default component.exports